import {Instance, types} from "mobx-state-tree";
import { v4 as uuidv4 } from 'uuid';
import {TaskList} from "./gql/serverTypes";

export type TaskListModelType = Instance<typeof TaskListModel>;

export const TaskListModel = types.model("TaskListModel")
    .props({
        id: types.optional(types.identifier, () => uuidv4()),
        name: types.string,
        description: types.optional(types.string, ''),
        childIds: types.optional(types.array(types.string), []),
        isArchived: types.optional(types.boolean, false),
        hasChanges: types.optional(types.boolean, false),
        createdAt: types.optional(types.string, ''),
        updatedAt: types.optional(types.string, ''),
        createdBy: types.optional(types.string, ''),
        updatedBy: types.optional(types.string, ''),
    })
    .views(self => ({
        get hasError() {
            return !self.name;
        }
    }))
    .actions(self => ({
        proceedSaveResults(obj: TaskList) {
            // @ts-ignore
            self.lastSavedObject = obj!;
        },
    }))
    .actions(self => ({
        resetHasChanges() {
            self.hasChanges = false;
        },
        setName(name: string) {
            self.name = name;
            self.hasChanges = true;
        },
        setDescription(desc: string) {
            self.description = desc;
            self.hasChanges = true;
        },
        setIsArchived(isArchived: boolean) {
            self.isArchived = isArchived;
            self.hasChanges = true;
        },
        addChildId(id: string, index: number = self.childIds.length) {
            self.childIds.splice(index, 0, id);
            self.hasChanges = true;
        },
        removeChildId(id: string) {
            const index = self.childIds.indexOf(id);
            if (index !== -1) {
                self.childIds.splice(index, 1);
                self.hasChanges = true;
            }
        },
        setCreatedAt(date: string) {
            self.createdAt = date;
        },
        setUpdatedAt(date: string) {
            self.updatedAt = date;
        },
        setUpdatedBy(userId: string) {
            self.updatedBy = userId;
        },
    })
);
